import React from 'react'
import { connect } from 'react-redux'

import { Toggle, Select, Button } from 'components/ui'
import { transformDataForSelect } from 'utils'
import { forWhomTypes } from '../../../../constants'
import OrderDestinationView from './View'

const mapStateToProps = state => ({
  cities: state.cities
})

export default connect(
  mapStateToProps
)(OrderDestinationContainer)

function OrderDestinationContainer({
  cities,
  onChangeCity,
  onChangeForWhom,
  onNextButtonClick,
  nextButtonDisabled,
  forWhom,
}) {
  return <OrderDestinationView
    citiesSelect={cities.isLoaded &&
      <div className='form-layout'>
        <div className='form-field'>
            {
              forWhom === forWhomTypes.OTHERS && 
                <Select placeholder="Ваш город"
                  options={transformDataForSelect(
                    cities.data.filter((city, index) => true /* || city.has_delivery === true */)
                  )}
                  label="Выберите город"
                  onChange={onChangeCity}
                />
            }
            {
              forWhom === forWhomTypes.YOURSELF && 
                <Select placeholder="Ваш город"
                  options={transformDataForSelect(
                    cities.data
                  )}
                  label="Выберите город"
                  onChange={onChangeCity}
                />
            }
        </div>
      </div>
    }

    forWhomToggle={
      <Toggle
        values={{
          left: {
            value: forWhomTypes.YOURSELF,
            label: 'Для себя'
          },
          right: {
            value: forWhomTypes.OTHERS,
            label: 'Для других'
          }
        }}
        name={'Order'}
        onChange={onChangeForWhom}
      />
    }

    nextButton={
      <Button
        blue
        text={'Продолжить'}
        onClick={onNextButtonClick}
        disabled={nextButtonDisabled}
      />
    }
  />
}
